/** Keyboard hints under the results, for sighted users only (hidden from assistive technology). */
export function CommandPaletteFooter(): React.JSX.Element {
  return (
    <div className="nb-palette-foot" aria-hidden="true">
      <span>
        <kbd className="nb-kbd">↑</kbd>
        <kbd className="nb-kbd">↓</kbd> navigate
      </span>
      <span>
        <kbd className="nb-kbd">Enter</kbd> open
      </span>
      <span>
        <kbd className="nb-kbd">Esc</kbd> close
      </span>
    </div>
  );
}
